import { render, staticRenderFns } from "./InvoiceCorrectionDialog.vue?vue&type=template&id=09547b96&scoped=true"
import script from "./InvoiceCorrectionDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceCorrectionDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCorrectionDialog.vue?vue&type=style&index=0&id=09547b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09547b96",
  null
  
)

export default component.exports